export const UNIT_TEMPLATE_TOPIC = '/topic/unit-template';

export enum UnitTemplateMessages {
  UnitTemplateSessionRefresh = 'UnitTemplateSessionRefresh',
}

export interface UnitTemplateSessionRefreshPayload {
  sessionId: string;
  childSessionId: string | null;
}
